import { ShopRow } from "@/types/db";
import { DateString, OpenSlotsByDateAndShopId, SelectedOpenSlotIdsByShopId, ShopId } from "../types";
import { useMemo } from "react";
import { WeeklyOpenSlotItem } from "../responses";
import { getShopBadgeClass } from "../color";
import TimelinePreview from "./TimeLinePreview";
import DressTourTimeLine, { DressTourTimelineSlot } from "@/components/combinations/DressTourTimeLine";
import { Shop } from "@/types/shop";
import ShopNaverMap from "@/components/common/NaverMap/ShopNaverMap";
import ReservationDateViewer from "@/components/common/reservation/ReservationDateViewer";



type DesktopDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  dressTourTimeLineSlots: DressTourTimelineSlot[];
  selectedShops: Shop[];
  selectedDate: string;
  onReset: () => void;
  onConfirm: () => void;
};

export default function DesktopDrawer({
  isOpen,
  onClose,
  dressTourTimeLineSlots,
  selectedShops,
  selectedDate,
  // weekDates,
  // openSlotsByDateAndShopId,
  // selectedOpenSlotIdsByShopId,
  // selectedShopIds,
  onReset,
  onConfirm,
}: DesktopDrawerProps) {
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/20 z-30 hidden md:block"
          onClick={onClose}
        />
      )}

      <div
        className={`fixed top-0 right-0 h-full w-[380px] bg-white border-l border-[#E5E7EB] z-40 flex flex-col transition-transform duration-300 ease-out hidden md:flex ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#E5E7EB] flex-shrink-0">
          <div>
            <p className="text-[11px] text-[#9CA3AF] font-medium uppercase tracking-wide">
              일정 확인
            </p>
            <h3 className="text-base font-bold text-[#111827]">선택한 방문 일정</h3>
          </div>
          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center hover:bg-[#F3F4F6] rounded-xl cursor-pointer"
          >
            <i className="ri-close-line text-xl text-[#374151]" />
          </button>
        </div>
        <div className='p-4'>
          <ReservationDateViewer targetDate={selectedDate} />
        </div>
        {
          dressTourTimeLineSlots.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16 text-center px-8">
              <div className="w-14 h-14 flex items-center justify-center bg-[#F3F4F6] rounded-2xl mb-4">
                <i className="ri-calendar-line text-2xl text-[#9CA3AF]" />
              </div>
              <p className="text-sm font-semibold text-[#374151]">선택된 일정이 없습니다</p>
              <p className="text-xs text-[#9CA3AF] mt-1.5 leading-relaxed">
                슬롯 그리드에서 방문 시간을 선택해주세요
              </p>
            </div>
          ) : (
            <DressTourTimeLine hideOtherButton={true}  slots={dressTourTimeLineSlots} />
          )
        }
        {
          selectedShops.length > 0 && (
            <ShopNaverMap
              style={{flex: 1}}
              slots={selectedShops}
              minHeight={100}
            />
          )
        }
        <div className="flex-shrink-0 border-t border-[#E5E7EB] px-4 py-4 bg-white space-y-2">
          <button
            onClick={onConfirm}
            className="w-full py-3.5 bg-[#2563EB] text-white text-sm font-bold rounded-xl hover:bg-[#1D4ED8] transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-calendar-check-line text-base" />
            예약 진행
          </button>

          <div className="flex gap-2">
            <button
              onClick={onReset}
              className="flex-1 py-3 bg-[#FFF1F2] text-[#BE123C] text-sm font-semibold rounded-xl hover:bg-[#FFE4E6] transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-1.5"
            >
              <i className="ri-refresh-line text-sm" />
              전체 초기화
            </button>
          </div>
        </div>
      </div>
    </>
  );
}